module.exports = __webpack_public_path__ + "img/multiple-products-24x-24.df646dbf.svg";